import React from 'react';
import { Link } from 'react-router-dom';
import { FaChevronRight } from 'react-icons/fa';
import './LoyaltyPages.css';
import PropTypes from 'prop-types';

class LoyaltyPages extends React.Component {
  render() {
    const { t } = this.context;

    const menuItems = [
      { title: t('YOUR BOOKINGS'), url: '/bookings' },
      { title: t('YOUR COINS'), url: '/wallet' },
      { title: t('REDEEM'), url: '/catalogue' },
      { title: t('MY REWARDS'), url: '/wallet' }
    ];

    return (
      <div className="loyalty-pages-container">
        <div className="admin-header">
          <h2>{t('MANAGEMENT')}</h2>
        </div>

        <div className="menu-list">
          {menuItems.map((item, index) => (
            <Link to={item.url} key={index}>
              <div className="menu-item">
                <span className="item-title">{item.title}</span>
                <FaChevronRight className="chevron-icon" />
              </div>
            </Link>
          ))}
        </div>
      </div>
    );
  }
}

LoyaltyPages.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default LoyaltyPages;
